<template>
    <div
        class="border border-black/5 dark:border-white/10 min-w-0 rounded-xl shadow-xs overflow-hidden bg-white dark:bg-white/[0.02]"
    >
        <div
            v-if="loading"
            class="animate-pulse flex"
            :class="{
                'p-4': size === 'md',
                'p-2': size === 'sm',
            }"
        >
            <div class="flex-1 space-y-2 py-1 flex flex-col">
                <div class="h-2 rounded bg-black/10 dark:bg-white/10"></div>
                <div class="h-2 rounded bg-black/10 dark:bg-white/10 w-1/2"></div>
            </div>
        </div>
        <div
            v-else
            class="flex items-center"
            :class="{
                'p-4': size === 'md',
                'p-2': size === 'sm',
            }"
        >
            <div class="w-full">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        loading: { type: Boolean, default: false },
        size: { type: String, default: "md" },
    },
};
</script>
